import styled from "styled-components";
import SmallPopupTemplate from "../small/SmallPopupTemplate";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import { Text } from "components/atoms/text/Text";
import { baseQueryInfo } from "utils/queryUtil";
import { getSwitchAccountList } from "api/accountAPI";
import { useEffect, useState } from "react";
import { useMenu } from "hook/useMenu";
import { useSelector } from "react-redux";
import { selectStomp } from "redux/stomp/stompSelector";
import { useNavigate } from "react-router-dom";
import { useAuth } from "components/Auth";
import { checkIsSuspended } from "utils/AccountUtil";
import { SUSPENSION_STATUS } from "redux/stomp/stompSubscriptionSlice";

type ModalProp = {};

const DeactivateOrganizationModal = (props: ModalProp) => {
  const [isDeactiaveModal, setIsDeactiaveModal] = useState<boolean>(false);
  const { isDeletedOrganization } = useSelector(selectStomp);
  const navigate = useNavigate();
  const auth = useAuth();
  const [isSwitchAccountNotice, setIsSwitchAccountNotice] =
    useState<boolean>(false);
  const { navigateSwitchAccount } = useMenu({});

  const onClickClose = () => {
    if (isDeletedOrganization && isDeactiaveModal) {
      auth.logout();
      setIsDeactiaveModal(false);
    }
    if (isSwitchAccountNotice) {
      setIsSwitchAccountNotice(false);
    }
  };

  useEffect(() => {
    if (isDeletedOrganization) {
      getSwitchAccountList({
        payload: {
          ...baseQueryInfo,
          pageLimit: 10000,
        },
      })
        .then(async (response) => {
          const accounts = (response?.result || []).filter(
            (account) =>
              checkIsSuspended(account) !== SUSPENSION_STATUS.DISABLED
          );
          if (accounts.length === 0) {
            setIsDeactiaveModal(true);
            return;
          }

          navigateSwitchAccount(
            {
              accountId: accounts[0].accountId,
              onSuccess: () => {
                setIsSwitchAccountNotice(true);
              },
              onFail: () => {
                navigate("/error/403");
              },
            },
            false
          );
        })
        .catch((err) => {
          navigate("/error/403");
        });
    }
  }, [isDeletedOrganization, auth.user]);

  if (isSwitchAccountNotice || (isDeletedOrganization && isDeactiaveModal)) {
    return (
      <SmallPopupTemplate
        title={""}
        onClick={onClickClose}
        confirmLabel="OK"
        data-testid="templates-modal-auth-small-popup-template-click-close"
      >
        <ModalText>
          You have been removed from the organization.
          {isSwitchAccountNotice && (
            <Text>You are being switched to another organization.</Text>
          )}
        </ModalText>
      </SmallPopupTemplate>
    );
  }
  return null;
};

export default DeactivateOrganizationModal;

const ModalText = styled.div`
  color: ${COLORS.RED};
  font-weight: 500;
  text-align: center;
  font-size: ${calcRem(20)};
  width: 100%;
  line-height: ${calcRem(24)};

  > div {
    padding-top: 10px;
  }
`;
